export default "__VITE_ASSET__Bv3qOR3J__"